import client from 'http/client';

/**
 * Does a login request on the API.
 *
 * @param {Object} payload
 * @param {string} payload.email
 * @param {string} payload.password
 * @returns {Promise}
 */
export const loginRequest = (payload) => {
    return client.post('/auth/login', payload);
};

/**
 * Does a logout request on the API.
 *
 * @returns {Promise}
 */
export const logoutRequest = () => {
    return client.get('/auth/logout');
};

/**
 * Does a password forgotten request on the API.
 *
 * @param {Object} payload
 * @param {string} payload.email
 * @returns {Promise}
 */
export const passwordForgottenRequest = (payload) => {
    return client.post('/auth/password-forgotten', payload);
};

/**
 * Does a user registration request on the API.
 *
 * @param {Object} payload
 * @param {string} payload.email - Required when not passing a password
 * @param {string} payload.password
 * @param {string} payload.username - Required when not passing an email
 * @param {string} [payload.first_name]
 * @param {string} [payload.last_name]
 * @returns {Promise}
 */
export const registerRequest = (payload) => {
    return client.post('/auth/register', payload);
};

/**
 * Does a relogin request on the API.
 *
 * @returns {Promise}
 */
export const reloginRequest = () => {
    return client.get('/@me/profile');
};



// WEBPACK FOOTER //
// ./src/http/requests/authRequests.js